import { render, staticRenderFns } from "./KBookingChat.vue?vue&type=template&id=6a877074&scoped=true&lang=pug&"
import script from "./KBookingChat.vue?vue&type=script&lang=ts&"
export * from "./KBookingChat.vue?vue&type=script&lang=ts&"
import style0 from "./KBookingChat.vue?vue&type=style&index=0&id=6a877074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a877074",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import KButton from '@/components/shared/Button/KButton.vue'
import KCard from '@/components/shared/Card/KCard.vue'
import KCardText from '@/components/shared/Card/KCardText.vue'
import KChip from '@/components/shared/Chip/KChip.vue'
import KLoader from '@/components/shared/Loader/KLoader.vue'
import KMeetingFileInput from '@/components/app/Meeting/KMeetingFileInput.vue'
import KOnlineStatus from '@/components/app/KOnlineStatus.vue'
import KTextChatMessage from '@/components/app/Meeting/KTextChatMessage.vue'
import KTypingIndicator from '@/components/app/KTypingIndicator.vue'
import KUserAvatar from '@/components/shared/User/KUserAvatar.vue'
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {KButton,KCard,KCardText,KChip,KLoader,KMeetingFileInput,KOnlineStatus,KTextChatMessage,KTypingIndicator,KUserAvatar,VDialog,VSlideYReverseTransition})
